import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles_m/tiles_m.css';
import '../styles/other.css';
import Axios from 'axios';
import { Link } from "react-router-dom";
import { navigate } from "@reach/router";

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import components
import RoundButton from '../components/RoundButton.js';

class AddProjectTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            listOfCountry: ([{id:1, label: "Czech republic"},{id:1, label: "United States"},{id:1, label: "Ukraine"}]),
            listOfPriority: ([{id:1, label: "High"},{id:1, label: "Medium"},{id:1, label: "Low"}]),
            selectedCountry: 0,
            selectedPriority: 0,
            note: "",
        }
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {


    }

    render() {
        return (
            <div className={"universalAddTile"} style={{position: "relative"}}>
                <span className="fontPoppinsSemiBold15 clickable">Add Project</span>

                <div style={{position: "relative", backgroundColor: "var(--lightest-gray)", marginTop: 20}}>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 25}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Project Name:*</span>
                        <input className="universalTextInput" type="text" style={{width: "100%", marginBottom: 5}} id="inputFirstName" name="inputFirstName" value={""} onChange={e => this.setState({ sectionLocationOpened: !this.state.sectionLocationOpened })}/>
                    </div>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Country:*</span>
                        <select className="universalTextInput topMenuSelectBox" name="country" id="country" style={{}} value={this.state.selectedCountry} onChange={e => this.setState({ selectedCountry: e.target.value })}>
                            <option value=""></option>
                            {this.state.listOfCountry.map(function (item) {
                                return (
                                   <option value={item.id}>{item.label}</option>
                                )
                            }.bind(this))}
                        </select>
                    </div>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Priority:*</span>
                        <select className="universalTextInput topMenuSelectBox" name="priority" id="priority" style={{}} value={this.state.selectedPriority} onChange={e => this.setState({ selectedPriority: e.target.value })}>
                            <option value=""></option>
                            {this.state.listOfPriority.map(function (item) {
                                return (
                                   <option value={item.id}>{item.label}</option>
                                )
                            }.bind(this))}
                        </select>
                    </div>

                    <div className="verticalStack" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 25}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: -5}}>Note:*</span>
                        <textarea className="modalInputAddNote" rows="4" style={{backgroundColor: "white"}} placeholder="" id="textAreaNote" name="textAreaNote" value={this.state.note} onChange={e => this.setState({ note: e.target.value })}></textarea>
                    </div>

                    <div className="horizontalStack" style={{paddingLeft: 20, paddingTop: 10, paddingRight: 25, paddingBottom: 20}}>
                        <RoundButton title={"Add Project"} className={"roundButtonOrange"} onClick={this.createNewAction} whiteText={true} />
                    </div>
                </div>

            </div>
        );
    }
}

export default AddProjectTile;
